import React, { Component } from "react";
import { FormLogin } from "../../components";
import "./styles.css";
import FormRegister from "../../components/FormRegister";

class Home extends Component {
  state = {
    signup: false
  };
  render() {
    return (
      <div className="home">
        <div className="content">
          <div className="content-box">
            <div className="how-thrive">
              <img src="/imgs/how-thrive.png" alt="How Thrive" />
            </div>
            {this.state.signup ? (
              <React.Fragment>
                <h1>Регистрирай се</h1>
                <FormRegister />
                {/* <a
                  href="javascript:void(0)"
                  onClick={() => this.setState({ signup: false })}
                >
                  влез в профил
                </a> */}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <h1>Влез в профил</h1>
                <FormLogin />
                {/* <a
                  href="javascript:void(0)"
                  onClick={() => this.setState({ signup: true })}
                >
                  регистрирай се
                </a> */}
              </React.Fragment>
            )}
          </div>
        </div>

        <div className="bg-1" />
        <div className="bg-2" />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/screens/Home/Home.js